export default {
    login: "login",
    users: "users",
    forgotPassword: "password/email",
    settings: "settings",
    patients: "patients",
    medicines: "drugs",
    medicineCategories: "drugs-categories",
    medicineNames: "drugs-name",
    prescriptions: "recipes",
    medicalRecords: "medical-records",
    contents: "contents",
    categories: "contents/categories",
    areas: "contents/categories-areas",
    contentItems: "contents/items",
    homeInfo: "home",
    calculatorTypes: "contents/items/calculator-type",
    appCrashes: "app-crash",
    usesInLactation: "drugs-list-lactation-use",
    usesInPregnancy: "drugs-list-pregnancy-use",
    contentItemsTabs: "contents-items-tab",
    planDetails: "plan-details",
    subscribeUser: "subscription-admin",
    unsubscribeUser: "cancel-subscription-admin",
    aiFiles: "files",
    sendNotification: "notification-all",
    sendEmail: "notification-all-email",
    feedback: "feedbacks",
    userCrm: "user-crm",
    updateCRMstatus: "updateCRMstatus",
    syncOfflineContent: "sync-offline-content",
    partnership: "partnerships",
    partnership_batches: "partnership-batches",
    partnership_codes: "partnership-codes",
    dashboardGeneral: "admin/dashboard/general",
    dashboardUsage: "admin/dashboard/usage",
    dashboardChurn: "admin/dashboard/churn",
    dashboardFinances: "admin/dashboard/finances",
    dashboardContent: "admin/dashboard/content",
    userSubscriptionHistory: "all-subscriptions",
    coupons: "coupons",
    couponsAvailablePlans: "coupons/available-plans",
    actionFeedbacks: "action-feedbacks",
    questionaires: "questionnaires",
    cancellation_reasons: "admin/cancellation-reasons/subscriptions",
    professionals: "admin/professionals",
} as const;